import { FeatureKey, FeatureModule } from '~/modules/feature-access/policy';
import { useAppSelector } from '~/store/hooks/useAppSelector';

export const useFeatureAccess = (): {
  getFeatureAccess: (module: FeatureModule, key: FeatureKey) => boolean;
} => {
  const features = useAppSelector(
    (state) => state.profile.user_policy?.features,
  );

  const getFeatureAccess = (
    module: FeatureModule,
    key: FeatureKey,
  ): boolean => {
    return !!features?.[module]?.[key] ?? true;
  };

  return { getFeatureAccess };
};
